var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9471 3.67188H21.739C25.1189 3.67188 27.859 6.4118 27.859 9.79167V19.5833C27.859 22.9632 25.1189 25.7031 21.739 25.7031H11.9471C8.56714 25.7031 5.82715 22.9632 5.82715 19.5833V9.79167C5.82715 6.4118 8.56714 3.67188 11.9471 3.67188ZM22.6625 10.0957C23.3385 10.0957 23.8865 9.54776 23.8865 8.87178C23.8865 8.19582 23.3385 7.64783 22.6625 7.64783C21.9865 7.64783 21.4385 8.19582 21.4385 8.87178C21.4385 9.54776 21.9865 10.0957 22.6625 10.0957ZM16.8444 9.1797C13.8024 9.1797 11.3364 11.6456 11.3364 14.6875C11.3364 17.7294 13.8024 20.1953 16.8444 20.1953C19.8862 20.1953 22.3523 17.7294 22.3523 14.6875C22.3556 13.2258 21.7763 11.8229 20.7427 10.7893C19.709 9.75569 18.3061 9.17644 16.8444 9.1797ZM13.4782 14.6856C13.4782 16.5446 14.9852 18.0515 16.8442 18.0515C18.7031 18.0515 20.2101 16.5446 20.2101 14.6856C20.2101 12.8267 18.7031 11.3197 16.8442 11.3197C14.9852 11.3197 13.4782 12.8267 13.4782 14.6856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/Ig.74094c4f1493a754ce0516654bc8de35.svg";
export { ForwardRef as ReactComponent };